import { useUnit } from 'effector-react'
import * as React from 'react'

import {
  $accounts,
  getAccounts,
  accountsMounted,
  $errorAccountsRequest,
} from './model'

export const useAccountsWidget = () => {
  React.useEffect(() => {
    accountsMounted()
  }, [])

  const accounts = useUnit($accounts)
  const errorAccountsRequest = useUnit($errorAccountsRequest)

  const loading = useUnit(getAccounts.pending)

  return {
    accounts,
    loading,
    errorAccountsRequest,
  }
}
